/**
 * @desc 分区导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.zoneTemplate.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/zoneTemplate/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
